import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import business from '../../services/business';
import Loading from '../Loading';
import Modal from '../Modal';
import InputForm from '../Form/InputForm';
import Search from '../Form/Search';
import { useCallback } from 'react';
import ReactPaginate from 'react-paginate';
import tools from '../../lib/tools';
import { toast as alert } from "react-toastify";
import config from '../../config/config';

export default function ModalMateriais({ hideModal, show, model, processo }) {

    const [state, setState] = useState({
        adicionando: false
    });

    const [materiais, setMateriais] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const [loader, setLoader] = useState(false);
    const [adicionandoMaterial, setAdicionandoMaterial] = useState(false);
    const [form, setForm] = useState({
        id_materiais_tipo: 1
    });
    const [validacao, setValidacao] = useState([]);
    const [text, setText] = useState('');
    const [pager, setPager] = useState({
        page: 1,
        total_pages: 0,
        total_rows: 0,
    });

    const handlePageClick = (e) => {
        getSearch(e.selected + 1, text);
    };

    const handleWindowSizeChange = (mobileSize) => {
        let checkIsMobile = window.innerWidth < mobileSize;
        setIsMobile(checkIsMobile);
    }

    const getSearch = useCallback(async (page = null, value = '', loading = true) => {
        setLoading(loading);
        let res = await business.getAllMateriais((page === null) ? pager.page : page, 10, value, processo.id_operadora);
        setMateriais(res?.response || [])
        if (res?.response && pager.page && res?.pager?.paginas > 0 && res?.pager?.paginas < pager.page) {
            pager.page = 1;
            return getSearch();
        }
        pager.page = res?.pager?.pagina;
        setPager({
            page: res?.pager?.pagina,
            total_pages: res?.pager?.paginas,
            total_rows: res?.pager?.total
        });
        setLoading(false);
        setSearchLoading(false);
        setLoader(true);
        // eslint-disable-next-line 
    }, []);

    const add = async (e, item) => {
        e.preventDefault();
        if (validate(form)) {
            setAdicionandoMaterial(true);
            item = { ...item, valor: (item?.valor) ? tools.prepareValue(item.valor) : 0.00, id_operadora: parseInt(item?.id_operadora || 0) };
            let { errors, response } = await business.addMaterial(item);
            if (errors && errors.length) {
                (errors).forEach(e => alert.error(e));
            } else {
                setState({ ...state, adicionando: false });
                if (response?.status) {
                    alert.success('O novo material foi cadastrado.');
                    item.valor_unitario = item.valor;
                    item.id = response.id;
                    delete item.valor;
                    materiais.shift();
                    materiais.unshift(item);
                    setMateriais(materiais);
                    model({
                        id_materiais_tipo: 1,
                        id: item.id,
                        nome: item.desc,
                        codigo: item.codigo,
                        valor_unitario: item.valor_unitario
                    });
                    hideModal(e);
                }
                setForm({});
            }
            setAdicionandoMaterial(false);
        }

    }

    const validate = useCallback((form) => {

        const obrigatorios = [];

        document.querySelectorAll('.modal-materiais [name][required]').forEach((e) => {
            if (e.name && e.style.display !== 'none') obrigatorios.push(e.name);
        });

        let validacao = {};
        let validated = true;

        obrigatorios.forEach(campo => {
            if ((!form && typeof form[campo] === 'undefined') || tools.isEmptyNullOrUndefined(form[campo])) {
                validacao[campo] = 'Campo Obrigatório';
                validated = false;
            }
        });

        setValidacao(validacao);

        return validated;
    }, []);

    const setModel = (name, value) => {
        setForm((prevState) => ({ ...prevState, [name]: value }));
    }

    useEffect(() => {
        if (!loader) {
            getSearch();
        }
        // eslint-disable-next-line 
    }, []);

    useEffect(() => {
        window.addEventListener('resize', () => {
            return handleWindowSizeChange(1180);
        });
    }, []);

    useEffect(() => {
        validate(form);
    }, [form, state, validate]);

    const renderForm = () => {
        return (loading) ? <Loading /> : (<>
            <div className="form-container grid col-12">
                <InputForm label="Código" type="text" mask={'###########'}
                    name="codigo" required className="span-3" maxLength={11} value={form?.codigo} model={setModel} error={validacao.codigo} />
                <InputForm label="Nome" type="text"
                    name="desc" required className="span-9" maxLength={64} value={form?.desc?.toUpperCase()} model={setModel} error={validacao.desc} />
                <InputForm label="Tipo" type="select" options={[
                    { id: 1, value: 1, label: 'Material', desc: 'Material' },
                    { id: 2, value: 2, label: 'Medicamento', desc: 'Medicamento' },
                ]}
                    name="id_materiais_tipo" required className="span-3"
                    value={form?.id_materiais_tipo} model={setModel} error={validacao.id_materiais_tipo} />
                <InputForm label="Valor" type="decimal"
                    name="valor" required className="span-3" value={form?.valor} model={setModel} error={validacao.valor} />
                {config.isSaastoUser() && <InputForm label="Tabela base" type="select" options={[
                    { id: 0, value: 0, label: 'säästö', desc: 'säästö' },
                    { id: 23, value: 23, label: 'CELOS', desc: 'CELOS' },
                ]} name="id_operadora" required className="span-3" value={form?.id_operadora || ''} model={setModel} />}
            </div>
            <div className="form-rodape mt-30">
                <button className="btn btn-outline-primary f700-16" onClick={() => setState({ ...state, adicionando: false })}>
                    Cancelar
                </button>
                <button className="btn btn-primary f700-16" onClick={(e) => add(e, form)} disabled={adicionandoMaterial}  >
                    {adicionandoMaterial ? <Loading /> : 'Salvar'}
                </button>
            </div>
        </>
        )
    }

    const renderGrid = () => {
        return (loading) ? <Loading /> : (
            <>
                <div className="flex">
                    <div className="col-4">
                        <Search placeholder="Digite o nome ou código.." defaultValue={text} onChange={(value) => {
                            setText(value);
                            setSearchLoading(true);
                            getSearch(1, value, false);
                        }} searchOnTyping={isMobile} loading={searchLoading} />
                    </div>
                    <div className="col-8">
                        <button className="btn btn-primary btn-md f700-16 float-right"
                            onClick={() => setState({ ...state, adicionando: true })}>Adicionar</button>
                    </div>
                </div>
                <div className="form-grid">
                    <div className="grid col-12 fb-16 p-10 mt-20">
                        <div className="span-1">Código</div>
                        <div className="span-9">Nome do material</div>
                        <div className="span-1">Tabela base</div>
                        <div className="span-1">Valor Unitário</div>
                    </div>
                    <div className="list-scroll">
                        {(materiais || []).map((material, i) => {
                            return <div key={i}>
                                <div className="grid col-12 fn-16 list-scroll-item" title="Clique para selecionar" onClick={(e) => {
                                    e.preventDefault();
                                    model({
                                        id_materiais_tipo: 1,
                                        id: material.id,
                                        nome: material.desc,
                                        codigo: material.codigo,
                                        valor_unitario: material.valor_unitario
                                    });
                                    hideModal(e);
                                }}>
                                    <div className="span-1">{material.codigo}</div>
                                    <div className="span-9">{material.desc.toUpperCase()}</div>
                                    <div className="span-1">{material.desc_operadora ? material.desc_operadora : 'säästö'}</div>
                                    <div className="span-1">{tools.formatCurrency(material.valor_unitario)}</div>
                                </div>
                            </div>
                        })}
                        {loader && !materiais?.length && (
                            <div>
                                <div className="grid col-12 convidados fn-16">
                                    <div className="span-12 text-center">Nenhum registro foi encontrado</div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="component pagination">
                        <div className="pagination-container">
                            {pager.total_pages < 2 ? '' : <ReactPaginate
                                previousLabel="«"
                                nextLabel="»"
                                breakLabel="..."
                                breakClassName="break-me"
                                page={pager.page - 1 ?? 0}
                                forcePage={pager.page - 1 ?? 0}
                                pageCount={pager.total_pages}
                                marginPagesDisplayed={3}
                                pageRangeDisplayed={5}
                                onPageChange={handlePageClick}
                                containerClassName="pagination"
                                subContainerClassName="pages pagination"
                                activeClassName="active" />}
                        </div>
                    </div>
                </div>
            </>
        )
    }

    return (
        <Modal show={show} handleClose={hideModal} style={{ maxWidth: '1300px', maxHeight: '725px' }} modalClass="modal-cad-usuario modal-materiais">
            <div className="flex">
                <div className="form w-100">
                    <h1 className="title mb-20">{state.adicionando ? 'Adicionar material' : 'Materiais'}</h1>
                    {state.adicionando ? renderForm() : renderGrid()}
                </div>
            </div>
        </Modal>
    );
}
